import { render, staticRenderFns } from "./ProductInfoBase.vue?vue&type=template&id=6dbebce3&scoped=true"
import script from "./ProductInfoBase.vue?vue&type=script&lang=js"
export * from "./ProductInfoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbebce3",
  null
  
)

export default component.exports